import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export function getMergedArrayOption(sources) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx) {
      var items, meta, addFromSource, name, value, uniqueItems;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              items = [];
              meta = {
                sources: []
              };

              addFromSource = function addFromSource(source, array) {
                if (array) {
                  var filtered = array.filter(Boolean);

                  if (filtered.length) {
                    items.push.apply(items, _toConsumableArray(filtered));
                    meta.sources.push(_objectSpread(_objectSpread({}, source), {}, {
                      toString: function toString() {
                        return "".concat(source.name, " ").concat(source.type);
                      }
                    }));
                  }
                }
              };

              _context.t0 = _regeneratorRuntime.keys(sources);

            case 4:
              if ((_context.t1 = _context.t0()).done) {
                _context.next = 19;
                break;
              }

              name = _context.t1.value;
              value = sources[name];

              if (!(typeof value === 'function')) {
                _context.next = 16;
                break;
              }

              _context.t2 = addFromSource;
              _context.t3 = {
                name: name,
                type: 'function'
              };
              _context.next = 12;
              return value(ctx);

            case 12:
              _context.t4 = _context.sent;
              (0, _context.t2)(_context.t3, _context.t4);
              _context.next = 17;
              break;

            case 16:
              if (value) {
                addFromSource({
                  name: name,
                  type: 'array'
                }, value);
              }

            case 17:
              _context.next = 4;
              break;

            case 19:
              uniqueItems = new Set(items);
              return _context.abrupt("return", [Array.from(uniqueItems), meta]);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}